import React from 'react';

import { Button, ButtonProps } from '@betterment/samba-react';

type SubmitOrderButtonProps = Pick<ButtonProps, 'disabled' | 'onClick' | 'css' | 'loading'>;

export const SubmitOrderButton: React.FC<SubmitOrderButtonProps> = ({ css, ...props }) => {
  return (
    <Button type="submit" spacing="default" variant="solidPrimary" css={{ alignSelf: 'start', ...css }} {...props}>
      Submit order
    </Button>
  );
};
